import { Component } from '@theme/component';
class StickyGroup extends Component {
    constructor() {
        super();
        this.mainBottomObserver = null;
        this.hiddenByBottom = false;
    }

    connectedCallback() {
        super.connectedCallback();
        if (this.dataset.stickyFixed) {
            this.#setupIntersectionObserver();
        }
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this.mainBottomObserver?.disconnect();
    }

  #setupIntersectionObserver () {
    const footer = document.querySelector('footer') ?? document.querySelector('[class*="footer-group"]');
    if (!footer) return;
    const fixedParallaxSection = document.querySelector('.footer-parallax-target');
    const isFixedFooter = fixedParallaxSection
      ? getComputedStyle(fixedParallaxSection).position === 'fixed'
      : false;
    const mainBottomTarget = isFixedFooter
      ? document.querySelector('.main-content-end-sentinel')
      : footer;
    if (!mainBottomTarget) return;

    const bottomObserverRootMargin = isFixedFooter ? '0px 0px 200px 0px' : '0px 0px 200px 0px';
    this.mainBottomObserver = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (!entry) return;

        if (entry.isIntersecting) {
          this.hiddenByBottom = true;
          this.#hideStickyGroup();
        } else if (!entry.isIntersecting && this.hiddenByBottom) {
            this.#showStickyGroup();
        }
      },
      {
        rootMargin: bottomObserverRootMargin,
      }
    );

    this.mainBottomObserver.observe(mainBottomTarget);
  }

  #showStickyGroup() {
    this.querySelector(".sticky-group")?.classList.remove("sticky-stuck")
  }

  
  #hideStickyGroup() {
    this.querySelector(".sticky-group")?.classList.add("sticky-stuck")
  }
}

if (!customElements.get('sticky-group')) {
  customElements.define('sticky-group', StickyGroup);
}